// when the customer success place order, save the event/status result to this
export const successTempEventStatus = {
  _value: undefined,
  getValue() {
    return this._value;
  },
  setValue(value) {
    this._value = value;
  },
};
